import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    areaOfInterest: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [fieldError, setFieldError] = useState('');
  const navigate = useNavigate();

  // 페이지 로드 시 상단으로 스크롤
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // 실제 전송 함수
  const sendMail = async () => {
    setIsSubmitting(true);
    setSubmitStatus(null);
    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message: formData.message,
          areaOfInterest: formData.areaOfInterest,
          email: formData.email.toLowerCase().trim(),
          fullName: formData.fullName,
        }),
      });
      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          fullName: '',
          email: '',
          areaOfInterest: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (err) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  // 폼 제출 시 바로 전송 (areaOfInterest 미선택 시 에러)
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.areaOfInterest) {
      setFieldError('Please select an area of interest.');
      return;
    }
    setFieldError('');
    sendMail();
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        {/* Left Section - Contact Information */}
        <div className="contact-info-section">
          <div className="contact-logo-title-row">
            <h1 className="contact-title">Contact us</h1>
          </div>
          <p className="contact-intro">
            Interested in learning more about digital assets? Fill out the contact form and a VegaX representative will be in touch shortly.
          </p>
          
          <div className="contact-details">
            <div className="contact-email">
              <a href="mailto:ir@vegaxholdings.com" className="email-link">
                ir@vegaxholdings.com
              </a>
            </div>
            <div className="social-media">
              <a href="https://vegaxholdings.medium.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                <img src="/images/socials/medium.svg" alt="Medium" style={{ width: 36, height: 36 }} />
              </a>
              <a href="https://twitter.com/vegaxholdings?lang=en" target="_blank" rel="noopener noreferrer" className="social-icon">
                <img src="/images/socials/twitter.svg" alt="Twitter" style={{ width: 36, height: 36 }} />
              </a>
              <a href="https://www.facebook.com/VegaXHoldings" target="_blank" rel="noopener noreferrer" className="social-icon">
                <img src="/images/socials/facebook.svg" alt="Facebook" style={{ width: 36, height: 36 }} />
              </a>
            </div>
          </div>
        </div>

        {/* Right Section - Contact Form */}
        <div className="contact-form-section">
          <form onSubmit={handleSubmit} className="contact-form">
            {fieldError && (
              <div className="error-message">{fieldError}</div>
            )}
            {submitStatus === 'success' && (
              <div className="success-message">
                Thank you for your message! We'll get back to you soon.
              </div>
            )}
            {submitStatus === 'error' && (
              <div className="error-message">
                Failed to send your message. Please try again later.
              </div>
            )}
            <div className="form-group">
              <label htmlFor="fullName" className="form-label">
                Full Name *
              </label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                placeholder="Enter your full name"
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email Address *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter your email address"
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="areaOfInterest" className="form-label">
                How can we help you?
              </label>
              <select
                id="areaOfInterest"
                name="areaOfInterest"
                value={formData.areaOfInterest}
                onChange={handleInputChange}
                className="form-select"
                required
              >
                <option value="" disabled hidden>Select area of interest</option>
                <option value="investment-product">Investment Product</option>
                <option value="otc">OTC</option>
                <option value="market-making">Market Making</option>
                <option value="others">Others</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="message" className="form-label">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Type your message"
                className="form-textarea"
                rows="5"
              ></textarea>
            </div>
            <button
              type="submit"
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'SENDING...' : 'SEND'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage; 